export default "__VITE_ASSET__89173352__"